import { observable } from "@legendapp/state";

/**
 * Minimum comfortable width (px) for the main content area. Below this the
 * layout starts yielding: the left nav collapses and the chat pane closes when
 * the block sidepane opens.
 */
export const MIN_CONTENT_WIDTH = 560;

/** Width (px) of the left navigation sidebar (`--sidebar-width` in `__root.tsx`). */
export const LEFT_NAV_WIDTH = 288;

/** Width (px) of the board block sidepane (`w-72` in `board.page.tsx`). */
export const BLOCK_SIDEPANE_WIDTH = 288;

/**
 * Grid container width (px) below which the board abandons its stored
 * 12-column layout and stacks blocks full-width in reading order. Shared
 * between `BoardGrid` (the actual stacking decision, measured) and
 * `useSidebarSync` (pre-emptively collapsing the left nav so the board only
 * stacks as a last resort).
 */
export const BOARD_STACK_THRESHOLD = 640;

/**
 * Live viewport width, kept current by a module-level `resize` listener. Used
 * to decide when docked panes should yield space to the main content.
 */
export const viewport$ = observable({
  width: typeof window === "undefined" ? 0 : window.innerWidth,
});

if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    viewport$.width.set(window.innerWidth);
  });
}
